module.exports = __webpack_public_path__ + "static/media/error_icon.b3d5509d.svg";